module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.adjustList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無配料群組，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    on: {
      "click": _vm.gotoCrAdjusts
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.adjustList), function(adjust, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === adjust.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === adjust.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickAdjust(adjust, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(adjust.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(adjust.remark))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.sub_type),
      expression: "adjustInfo.sub_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adjustInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("大小")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 20
    }
  }, [_vm._v("容器")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 30
    }
  }, [_vm._v("甜度")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 40
    }
  }, [_vm._v("溫度")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("其他")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.name),
      expression: "adjustInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.adjustInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.sort),
      expression: "adjustInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.adjustInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_mandatory),
      expression: "adjustInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adjustInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_mandatory),
      expression: "adjustInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adjustInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.min_limit),
      expression: "adjustInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.max_limit),
      expression: "adjustInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.remark),
      expression: "adjustInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adjustInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_common),
      expression: "adjustInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adjustInfo.is_common, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_common", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.is_common),
      expression: "adjustInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adjustInfo.is_common, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adjustInfo, "is_common", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.price),
      expression: "adjustInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "調整類別內的選項皆為此價格",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.adjustInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.price_type),
      expression: "adjustInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adjustInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.calorie),
      expression: "adjustInfo.calorie"
    }],
    ref: "calorie",
    staticClass: "form-control",
    attrs: {
      "placeholder": "調整類別內的選項皆為此熱量",
      "type": "text"
    },
    domProps: {
      "value": (_vm.adjustInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "calorie", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.description),
      expression: "adjustInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adjustInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adjustInfo.vendor_custom_id),
      expression: "adjustInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.adjustInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adjustInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("配料")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    }
  }, [_vm._v("\n                  選擇配料\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.optionList), function(option) {
    return (option.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.adjustList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrAdjusts
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.adjustList.length) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.optionList,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("配料群組")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("分類")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("調整類別名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序\n                "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "data-container": "body",
      "title": "菜單上呈現分類順序預設為：(大小)>(溫度>甜度>容器)>(其他)，括弧內的項目可依排序值調整順序。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8131362c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrAdjustTemp.vue
// module id = 2505
// module chunks = 1